export default "__VITE_ASSET__BV1m4MDf__"